module.exports = __webpack_public_path__ + "static/media/giftPragmatic1.e37a3f8f.webp";